import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Check, X } from 'react-feather';
import theme from 'constants/theme';
import stylesCourse from 'styles/Course.module.scss';
import { Alert, UncontrolledTooltip } from 'reactstrap';
import { parseHtml } from 'helpers';
import { useViewMode } from 'hooks';
import { USER_ROLES } from 'constants/constants';
const OrderingResult = ({
  result,
  showYourAnswer,
  showCorrect,
  showCorrectIcon,
  iconsShow,
  isModal,
  showPlain = true,
}) => {
  const viewMode = useViewMode();

  return (
    <div>
      {showCorrect && showPlain && (
        <div className="freetext-correct-ans">
          {(result?.shuffledAnswers || result?.data)?.map((item, index) => (
            <div key={index} className={`mb-1 ${isModal ? '' : ''}`}>
              <div
                className={
                  `flexRow px-md-2 px-05 py-05 ${stylesCourse['item-section-normal']}` +
                  ` ${stylesCourse['item-section-enabled']}`
                }
                style={{ '--labelcolor': '#c1c9d4' }}
              >
                <div className="col">
                  <div className="row">
                    <span
                      className={`w-100 mtc-order-width fill-overflow-image ${stylesCourse['item-unit-title']}`}
                    >
                      <span>{parseHtml(item)}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {showCorrect && (
        <div className="freetext-correct-ans">
          <span className={`view-page-title`}>Correct Answer: </span>
          <Alert className={`mt-05 show`}>
            {result?.resultAnswers?.map((item, index) => {
              return (
                <div key={index}>
                  <div
                    className={
                      `flexRow ${stylesCourse['item-section-normal']}` +
                      ` ${stylesCourse['item-section-enabled']}`
                    }
                    style={{
                      '--labelcolor': iconsShow ? '#19a356' : '#c1c9d4',
                    }}
                  >
                    {iconsShow && (
                      <div
                        className="preview_test_correct_lebalgrade"
                        style={{ marginLeft: 'auto' }}
                      >
                        Correct
                      </div>
                    )}
                    <span
                      className={`w-100 px-md-2 px-05 py-05 ${stylesCourse['item-unit-label']}`}
                    >
                      <span
                        className={`w-100 mtc-order-width fill-overflow-image ${stylesCourse['item-unit-title']}`}
                      >
                        <strong>{parseHtml(item?.content)}</strong>
                      </span>
                    </span>
                  </div>
                  {/* {iconsShow && (
                      <span className={stylesCourse['item-unit-label']}>
                        <span className="pl-1">
                          <>
                            <Check color={theme.success} id="success" />
                            <UncontrolledTooltip
                              placement="right"
                              target="success"
                            >
                              This was the correct answer
                            </UncontrolledTooltip>
                          </>
                        </span>
                      </span>
                    )} */}
                </div>
              );
            })}
          </Alert>
        </div>
      )}
      {showYourAnswer && (
        <div className="freetext-correct-ans">
          <strong className="view-page-title">
            {' '}
            {viewMode === USER_ROLES.LEARNER ? 'Your Answer' : 'Learner Answer'}
            :{' '}
          </strong>
          <Alert className={`mt-05 show`}>
            {result?.result?.map((item, index) => {
              return (
                <div key={index}>
                  <div
                    className={
                      `flexRow ${stylesCourse['item-section-normal']}` +
                      ` ${stylesCourse['item-section-enabled']}`
                    }
                    style={{
                      '--labelcolor': iconsShow
                        ? showCorrect
                          ? result?.resultAnswers[index]?.correct
                            ? '#19a356'
                            : '#e16969'
                          : '#c1c9d4'
                        : '#c1c9d4',
                    }}
                  >
                    {iconsShow ? (
                      showCorrect ? (
                        <>
                          {result?.resultAnswers[index]?.correct ? (
                            <div
                              className="preview_test_correct_lebalgrade"
                              style={{ marginLeft: 'auto' }}
                            >
                              Correct
                            </div>
                          ) : (
                            <div
                              className="preview_test_wrong_lebalgrade"
                              style={{ marginLeft: 'auto' }}
                            >
                              Incorrect
                            </div>
                          )}
                        </>
                      ) : null
                    ) : null}

                    <span
                      className={`w-100 px-md-2 px-05 py-05 ${stylesCourse['item-unit-label']}`}
                    >
                      <span
                        className={`w-100 mtc-order-width fill-overflow-image ${stylesCourse['item-unit-title']}`}
                      >
                        <strong>{parseHtml(item)}</strong>
                      </span>
                    </span>
                  </div>
                  {/* 
                  {iconsShow && (
                    <span className={stylesCourse['item-unit-label']}>
                      <span className="pl-1">
                        {result?.resultAnswers[index]?.content == item ? (
                          <>
                            <Check color={theme.success} id="success" />
                            <UncontrolledTooltip
                              placement="right"
                              target="success"
                            >
                              This was the correct answer
                            </UncontrolledTooltip>
                          </>
                        ) : (
                          <>
                            <X color={theme.danger} id="failed" />
                            <UncontrolledTooltip
                              placement="right"
                              target="failed"
                            >
                              This was the wrong answer
                            </UncontrolledTooltip>
                          </>
                        )}
                      </span>
                    </span>
                  )} */}
                </div>
              );
            })}
          </Alert>
        </div>
      )}
    </div>
  );
};

OrderingResult.propTypes = {
  result: PropTypes.object.isRequired,
};

export default OrderingResult;
